module.exports = __webpack_public_path__ + "img/spinner.95e01057.svg";